import { rmaItemsAccessoriesMf, rmaItemsAccessoriesModelMf, rmaItemsEquipmentMf, rmaItemsEquipmentModelMf } from 'models/rmamanufatura/detailsRma';

export class NewEquipmentModelMf {
    id?: any
    partNumber?: string
    partNumberModel?: string
    rmaItemsAccessories?: rmaItemsAccessoriesMf
    rmaItemsEquipment?: rmaItemsEquipmentMf
    serviceType?: {}
    serviceTypeId?: any
    user?: {}
    userId?: any
}
export class NewEquipmentMf{
    serviceTypeId?: number | null
    ssoId?: string
    model?: string | null
    rmaId?: number | null
    justify?: string
    rmaItemsEquipment?: rmaItemsEquipmentModelMf | null
    rmaItemsAccessories?: rmaItemsAccessoriesModelMf | null

    constructor(){
        this.serviceTypeId = null
        this.model = null
        this.rmaItemsEquipment = null;
        this.rmaItemsAccessories = null;
    }
}
